import React from 'react';
import s from '../../../styles/Form.module.scss'
import '../../../styles/buttons.scss'

export const PhoneVerificationForm = ({
  loading,
  error,
  verificationCode,
  setVerificationCode,
  phoneNumber,
  onVerifyCode,
  onReset,
}) => (
  <form onSubmit={onVerifyCode} className={s.form}>
    <label
      htmlFor="verificationCode"
      className={s.label}
    >
      Verification Code
    </label>
    <input
      id="verificationCode"
      type="text"
      value={verificationCode}
      onChange={e => setVerificationCode(e.target.value)}
      placeholder="123456"
      inputMode="numeric"
      required
      className={s.input}
    />
    <div className='btn-wrap'>
      <button
        type="submit"
        disabled={loading}
        className={`btn btn-primary ${loading ? 'loading' : ''}`}
      >
        {loading ? 'Verifying...' : 'Verify Code'}
      </button>
      <button
        className={`btn btn-orange ${loading ? 'loading' : ''}`}
        type="button"
        onClick={onReset}
      >
        Reset
      </button>
    </div>
  </form>
);
